export default {
  aboutservice: {
    subtitle: "// اطلب بذكاء وأنفق أقل لـ",

    title: "المطاعم",

    desc:
      "اشترِ بذكاء واعمل بكفاءة. تواصل مع الموردين، قم بإنشاء وتتبع الطلبات، استكشف سوقًا متكاملًا، وأنشئ أوامر الشراء بسهولة — كل ذلك داخل منصة MAHAL. نظام واحد. تحكم كامل.",

    text:
      "اطلب بذكاء وأنفق أقل. تواصل مع الموردين، أنشئ وتتبع الطلبات، واستكشف السوق الكامل — كل ذلك في منصة MAHAL الموحدة. كفاءة حقيقية وسهولة في الاستخدام.",

    cta: "بوابة المطاعم",


    
  },
};